/* Text with masonry gallery */
import 'slick-carousel';

export function text_with_masonry_gallery() {

    $(document).ready(() => {

		if ( $( '.block--text-with-masonry-gallery' ).length <= 0 ) {
			return;
		}

        $('.block--text-with-masonry-gallery--carousel').slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 0,
            responsive: [{
                breakpoint: 992,
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                }
            }]
        });
    });

}
